import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import PaytaxServices from './paytax-service';
import { CALCULATOR_DATA, TAX_RESULT } from './types';

export const useDebouncedTaxCalculation = (
  inputTabData: CALCULATOR_DATA | null | undefined,
  setTaxResult: ((result: TAX_RESULT | null) => void) | undefined,
  minLength = 5
) => {
  const [currentState, setCurrentState] = useState('');

  const handleTaxCall = async () => {
    if (!inputTabData) return;
    try {
      const result = await PaytaxServices.getCalculation(
        '/f/itr/tax_calculator_results/',
        inputTabData
      );
      setTaxResult?.(result);
    } catch (error) {
      console.error('Error calculating tax:', error);
      setTaxResult?.(null);
    }
  };

  const debouncedHandleTaxCall = useMemo(
    () => debounce(handleTaxCall, 500),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [inputTabData]
  );

  useEffect(() => {
    if (currentState.length > minLength) {
      debouncedHandleTaxCall();
    }
    return () => debouncedHandleTaxCall.cancel();
  }, [inputTabData, currentState, debouncedHandleTaxCall, minLength]);

  return { currentState, setCurrentState };
};
